var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.554,
    height: 18.554,
    viewBox: "0 0 18.554 18.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-user",
    d: "M12.37,18.024a9.281,9.281,0,0,1-6.185,0V16.235a3.092,3.092,0,1,1,6.185,0ZM9.277,5.412a1.546,1.546,0,1,0,1.546,1.546A1.548,1.548,0,0,0,9.277,5.412Zm9.277,3.866a9.282,9.282,0,0,1-4.639,8.032V16.235a4.639,4.639,0,1,0-9.277,0v1.074A9.276,9.276,0,1,1,18.554,9.277ZM12.37,6.958A3.092,3.092,0,1,0,9.277,10.05,3.1,3.1,0,0,0,12.37,6.958Z",
    fill: "#23bee3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a954662ca875a7acae905acb063d9bea.svg";
export { ForwardRef as ReactComponent };